import { Title } from './styles';

export default Title;
